// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2U7jN","productName":"Table_productName__SpXDP"};